export default __webpack_public_path__ + "static/acquire-c307871fadb088306292b42d1e787814.webp";